import React from 'react';
import { ContentBoxContainer, ContentBoxText, Decoline, PenlySeo, Spacer } from 'components';
import { fromTablethoriMediaQuery, mediaQueries } from 'utils/MediaQueriesDeprecated';

export default function OmRaadgivningen() {
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);
    const title = 'Ekspertrådgivning hos Penly';
    const description =
        'Hos Penly er det vores mål, at gøre dig klogere på din privatøkonomi. '
        + 'Vi prioriterer uafhængig og kompetent pensionsrådgivning højt. Læs mere.';

    return (
        <>
            <PenlySeo title={ title } description={ description } />

            <ContentBoxContainer className="single blogEntryIntro leftPriority mobileflip tabletflip">
                <ContentBoxText style={{ paddingTop: 40 }}>
                    <h2 className="nomb">Ekspertrådgivning gennem Tom Clausen og Nordic Insure</h2>
                    <Decoline className="large" />
                </ContentBoxText>
            </ContentBoxContainer>

            <ContentBoxContainer>
                <ContentBoxText className="noTp single80">
                    <p>
                        Hos Penly prioriterer vi uafhængig og kompetent pensionsrådgivning højt.
                        Derfor samarbejder vi nu med Tom Clausen fra Nordic Insure, som har
                        mange års erfaring med at rådgive både selvstændige og lønmodtagere om
                        pension og forsikringer.
                    </p>
                    <p>
                        Tom er autoriseret forsikringsmægler med en baggrund i den finansielle
                        sektor siden 1886. Han har specialiseret sig i at hjælpe kunder med at få
                        overblik over deres pensionsforhold og finde skræddersyede løsninger, der
                        matcher både deres livssituation og fremtidsplaner. Du kan se tilladelsen
                        til Nordic Insure på Finanstilsynets hjemmeside <a
                            href="https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=228540E3-56D8-E811-813C-00505680286D"
                            target="_blank"
                            rel="noreferrer"
                        >
                            her
                        </a>.
                    </p>
                    <h4>Toms tilgang er Penlys tilgang</h4>
                    <p>
                        Vi deler missionen om at gøre det lettere for danskerne at få mest muligt
                        ud af deres pensionsopsparing. Tom arbejder målrettet på at skabe
                        gennemsigtighed og værdi i rådgivningen.
                    </p>
                    <h3>Penly Invest</h3>
                    <h4>Investeringsrådgivning</h4>
                    <p>
                        Penly Invest er Penlys investeringsben, hvor vi tilbyder rådgivning, der
                        gør investering forståeligt og gennemskueligt. Søren Risager Rasmussen er
                        direktør og medstifter af Penly Invest og ansvarlig rådgiver for
                        investeringsområdet.
                    </p>
                    <p>
                        Søren Risager Rasmussen har mange års erfaring med investering og
                        formueplanlægning – både fra bankverdenen og som tidligere direktør i
                        SKAGEN Fondene. Søren brænder for at gøre investering forståeligt og
                        gennemskueligt, så helt almindelige danskere kan træffe kloge beslutninger
                        og få mere ud af deres penge.
                    </p>
                    <p>
                        Penly Invest har licens til at yde rådgivning og er under tilsyn af
                        Finanstilsynet - <a
                            href="https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=AFE8A61C-CC92-F011-A202-005056901D70"
                            target="_blank"
                            rel="noreferrer"
                        >
                            se mere her.
                        </a>
                    </p>
                    <h3>Juridisk rådgivning</h3>
                    <h4>Familiejura</h4>
                    <p>
                        Økonomi hænger ofte sammen med jura. Derfor kan du få juridisk rådgivning
                        gennem vores samarbejdspartner:
                    </p>
                    <p>
                        <strong>Lisbeth Egede Andersson, Alliance Advokater Hørsholm</strong>
                    </p>
                    <p>
                        Lisbeth er registreret i Advokatnøglen - <a
                            href="https://www.advokatnoeglen.dk/advokat/lisbeth-egede-a9a6fe53-d658-4ab2-bb3c-111593bc872f"
                            target="_blank"
                            rel="noreferrer"
                        >
                            se mere her.
                        </a>
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            { fromTablethori && <Spacer size="medium" /> }
        </>
    );
}
